export enum BucketCompartmentEnum {
  PUBLIC = 'public',
  PRIVATE = 'private',
  WEBSITE = 'website',
  FOLDER = 'folder',
  IMAGES = 'images',
  DOCUMENTS = 'documents',
  VIDEOS = 'videos',
  AUDIO = 'audio'
} 